import React from 'react';
import Typography from '@material-ui/core/Typography';
import withRoot from '../withRoot';
import Layout from "../components/Layout";
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  text: {
    maxWidth: 480,
    height: "65vh"
  }
};

function About(props) {
  const { classes } = props;

  return (
    <Layout>
      <Grid container justify="center" spacing={16}>
        <Grid item md={12} xs={12}>
          <Typography variant="h1" justify="center" gutterBottom>
            About
          </Typography>
        </Grid>
        <Grid container className={classes.text}>
          <Grid item md={12} xs={12}>
            <Typography variant="body1" component="div" align="justify">
              <p>
                Alpha version of the gym.js reinforcement learning library.
              </p>
              <p>
                More environments, examples and a better interface are coming up. If you would like to
                contribute, please <a href="https://github.com/ttumiel/gym.js">see here</a>.
              </p>
              <p>
                What's the Purpose?
              </p>
              <ul>
                <li>To create an easy to enter, friendly community of reinforcement learning challenges.</li>
                <li>Allow interactive programming on RL environments.</li>
                <li>Develop interactive, multi-agent environments.</li>
                <li>Increase speed of development.</li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Layout>
  );
}

export default withRoot(withStyles(styles)(About));
